import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FullModeService } from 'src/app/services/full-mode.service';

@Component({
  selector: 'app-working-language',
  templateUrl: './working-language.component.html',
  styleUrls: ['./working-language.component.scss']
})
export class WorkingLanguageComponent implements OnInit {
  constructor(
    public translate: TranslateService,
    public route:ActivatedRoute,
    public fullModeService: FullModeService
  ) { }
  List: any[] = [];
  Languages: any[] = [
    { title: 'MARIA_DB_CLOUD' },
    { title: 'MYSQL_COMPATIBLE' },
    { title: 'GALERA_CLUSTER_COMPATIBLE' },
    { title: 'SQLITE_COMPATIBLE' },
    { title: 'SQLITE_SYNC' },
    { title: 'CREATOR_DESCRIPTION' },
  ]

  titleSectionProp: any = {
    class: 'iq-title-box-2',
    title: 'SYNC_ALL_DEVICES',
    description: 'SYNC_ALL_DEVICES_DESCRIPTION',
    titleClass: 'text-white',
    descClass: 'text-white'
  };

  ngOnInit(): void {
  }
  redirectToCreator(){
    if(this.fullModeService.fullMode==false){
      window.open('https://creator.se2.tech/#/?fullMode=false', '_blank');
    }else{
      window.open('https://creator.se2.tech/#/', '_blank');
    }
  }

}
